import PromptList from './PromptList';

const rootIA = 'ai/';
const routes = [
    { path: rootIA + 'prompts', component: () => <PromptList />, isSidebar: true, isPublic: false, permissions: ['view_ia'] },
];

export default routes;
